
// import AdminPasswordModal from "~/components/Modal/Password.vue";

export default {
  components: {
    // AdminPasswordModal,
  },
  computed: {
    // 1. Checks if the current session has successfully authenticated
    isAccessGranted() {
      // Assuming this state is set to TRUE upon successful login via the modal
      return this.$$display;
    },

    // 2. Checks if the backend requires a password at all (The optional part)
    isSecurityEnabled() {
      // You need to load this state/config when the app mounts or the component loads.
      // For example, fetch it in Nuxt's 'fetch' or 'asyncData'.
      return this.$store.state.config.adminSecurityEnabled;
    },
  },

  mounted() {
    if (!this.isAccessGranted) {
      this.$vmodal.open({
        component: () => ({
          component: import("~/components/Modal/Password.vue"),
          delay: 200,
          timeout: 3000,
        }),
        props: {
          configs: this.configs,
        },
        wrapperProps: {
          clickCloseOutside: true,
          classes: "pre-default-modal",
        },
      });
    }
  },
};
